import initSmpFansUnitedSDK from '../lib/SMPFansUnitedSDK';
import { predictor } from '../api';

// eslint-disable-next-line camelcase
import { FansUnitedSDKOptions as fansUnitedOptions } from '../types';

export default function useFansUnitedApi(sdkOptions: fansUnitedOptions) {
  const sdkFansUnited = initSmpFansUnitedSDK(sdkOptions);

  return {
    $predictor: predictor(sdkFansUnited),
  };
}
